import { render, staticRenderFns } from "./creatBand.vue?vue&type=template&id=82c5f6e8&scoped=true"
import script from "./creatBand.vue?vue&type=script&lang=js"
export * from "./creatBand.vue?vue&type=script&lang=js"
import style0 from "./creatBand.vue?vue&type=style&index=0&id=82c5f6e8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c5f6e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82c5f6e8')) {
      api.createRecord('82c5f6e8', component.options)
    } else {
      api.reload('82c5f6e8', component.options)
    }
    module.hot.accept("./creatBand.vue?vue&type=template&id=82c5f6e8&scoped=true", function () {
      api.rerender('82c5f6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/brand/creatBand.vue"
export default component.exports